module.exports = __webpack_public_path__ + "img/pic_france_07.f5995036.jpg";